import React, {useContext} from 'react';
import {Space} from 'antd';
import {observer} from "mobx-react";
import * as Translation from "../index";
import {StoreContext} from "../../../store.context";
import {TranslationDomainEnum} from "../../../types/enums";
import {Helmet} from "react-helmet-async";

export const EntityImport: React.FC = observer(() => {
    const {appStore: {translate}} = useContext(StoreContext);
    const translationDomain = TranslationDomainEnum.MESSAGES;
    const title = translate('userMenuItemEnum.entity_translation_import', {}, translationDomain);

    return (
            <>
                <Helmet>
                    <title>{`CL BO - ${title}`}</title>
                </Helmet>
                <Space direction="vertical" size="small" style={{display: 'flex'}}>
                    <Translation.EntityImportForm/>
                </Space>
            </>
    )
})